module.exports = __webpack_public_path__ + "img/4_hsgeoje.f2f6db81.jpg";